// A strip cell's line in a state's tone (Console D's c-warn, c-crash), for the package's Strip.
import type { StripItem } from '@apsio/ui'
import type { ReactNode } from 'react'

export type TonedItem = StripItem & { d?: ReactNode; tone?: 'warn' | 'crash' | undefined }

export const toned = (items: TonedItem[]): StripItem[] =>
  items.map(({ tone, d, ...item }) => ({
    ...item,
    ...(d === undefined || d === null
      ? {}
      : { d: tone ? <span className={`c-${tone}`}>{d}</span> : d }),
  }))
